// Mock portfolio used by the investor Portfolio Overview page.
// Each entry represents a company the current investor has access to.
//
// When Supabase is wired, replace this file with a fetch from a
// `company_investors` join table and hydrate each company record from
// its `investor_snapshots` table.

export const MOCK_PORTFOLIO = [
  {
    id: 'pmd',
    name: 'Demo Medical Devices Inc.',
    industry: 'Medtech',
    hq: 'Montreal, QC',
    logo: '/finkloz-light.png',
    cashCad: 35900000,
    runwayMonths: 28,
    headcount: 51,
    lastPublishedAt: '2026-01-15T14:30:00Z',
    lastPublishedBy: 'Taylor Brooks',
    status: 'published',
    // If this matches activeCompany.id in the app, clicking drills into
    // the full existing investor report instead of a placeholder.
    isCurrent: true,
  },
  {
    id: 'neurolux',
    name: 'NeuroLux Therapeutics',
    industry: 'Biotech',
    hq: 'Boston, MA',
    logo: null,
    cashCad: 52400000,
    runwayMonths: 26,
    headcount: 41,
    lastPublishedAt: '2026-02-28T11:05:00Z',
    lastPublishedBy: 'Samir Patel',
    status: 'published',
  },
  {
    id: 'brightcell',
    name: 'BrightCell Diagnostics',
    industry: 'Diagnostics',
    hq: 'San Diego, CA',
    logo: null,
    cashCad: 19820000,
    runwayMonths: 14,
    headcount: 28,
    lastPublishedAt: '2026-01-04T09:00:00Z',
    lastPublishedBy: 'Marta Ruiz',
    status: 'published',
  },
  {
    id: 'helio-one',
    name: 'Helio One Energy',
    industry: 'Cleantech',
    hq: 'Calgary, AB',
    logo: null,
    cashCad: 8150000,
    runwayMonths: 9,
    headcount: 17,
    lastPublishedAt: '2025-11-30T17:45:00Z',
    lastPublishedBy: 'James Okoye',
    status: 'published',
  },
  {
    id: 'atlas-ag',
    name: 'Atlas Agronomics',
    industry: 'Agtech',
    hq: 'Guelph, ON',
    logo: null,
    cashCad: null,
    runwayMonths: null,
    headcount: null,
    lastPublishedAt: null,
    lastPublishedBy: null,
    status: 'not_published', // triggers "Data available soon" on the card
  },
  {
    id: 'river-robotics',
    name: 'River Robotics',
    industry: 'Industrial AI',
    hq: 'Waterloo, ON',
    logo: null,
    cashCad: 31250000,
    runwayMonths: 22,
    headcount: 36,
    lastPublishedAt: '2026-02-10T08:20:00Z',
    lastPublishedBy: 'Emma Lindqvist',
    status: 'published',
  },
];
